import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/services/api.service';
import { CustomerService } from 'src/app/services/customer.service';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-require-tnc',
  templateUrl: './tnc.component.html',
  styleUrls: ['./tnc.component.scss'],
})
export class TncComponent  implements OnInit {
  tnc!: any

  form = new FormGroup({
    code: new FormControl('')
  })

  constructor(private customerService: CustomerService,
    private activeModal: NgbActiveModal,
    private settingsService: SettingsService,
    private apiService: ApiService,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.titleService.setTitle($localize`Terms and conditions`)

    this.settingsService.tnc(this.apiService.organizationId() as number).subscribe((tnc) => {
      this.tnc = tnc
    })
  }

  accept() {
    this.customerService.acceptTnC().subscribe({
      next: () => {
        this.customerService.ping().subscribe({
          next: () => this.activeModal.close(),
          error: () => this.activeModal.close()
        })
      }
    })
  }

  refuse() {
    alert($localize `You must accept the terms & conditions to continue.`)
  }
}
